import { useState } from 'react';
import { toast } from 'react-toastify';

import { SnapshotRepublicationPayload, eventingApi } from '../../../../../services/eventingApi';

export const useSnapshotRepublication = (onDone: () => void) => {
  const [submitting, setSubmitting] = useState(false);

  const request = async (payload: SnapshotRepublicationPayload) => {
    setSubmitting(true);
    try {
      const result = await eventingApi.createSnapshotRepublication(payload);
      toast.success(`RepublishSnapshot pedido ao ${result.data.sourceService} para ${result.data.aggregateIds.length} agregado(s) → ${result.data.target}`);
      onDone();
    } catch (error) {
      toast.error((error as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return { submitting, request };
};
